import React, { useState } from 'react'
import { DatePicker, Dropdown, Menu } from 'antd'
import { Route, Switch, useHistory, Link } from 'react-router-dom'

import { AiOutlineDown } from 'react-icons/ai'

import { useToggle, stringifyDate, useListData, trimText } from '../../modules'

import Receive from '../../components/reusable/receive'

import NewMessage from '../../components/drawers/newMessage'
import Message from '../../components/drawers/message'

import moment from 'moment'
import Pagination from '../../components/reusable/pagination'

const { RangePicker } = DatePicker

const Messages = () => {
    const [ranges, setRanges] = useState()
    const [selected, setSelected] = useState(null)
    const [string, setString] = useState('')
    const [token, setToken] = useState()

    const history = useHistory()

    const [visible, toggleVisible] = useToggle(true)
    const [committed, toggleCommitted] = useToggle()

    const [
        { loading: invLoading, error: invError, fetch },
        { list: invoices },
        { navigate, page = 1, limit = 5 }
    ] = useListData('invoices', ranges ?
        { string, from: ranges[0]?._d ?? null, to: ranges[1]?._d ?? null, committed }
        : { string, committed }
        , { notify: true, manual: false })

    const refetch = () => {
        fetch()
        navigate(1)
    }

    const selectRange = range => {
        setRanges(range)
        refetch()
    }

    const search = str => {
        setString(str)
        if (str?.trim().length > 2 || str.length === 0)
            refetch()
    }

    const messages = [
        {
            id: 1,
            recipient: 'John Doe',
            createdBy: 'Dummy',
            status: false,
            message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl eget aliquam ultricies, nunc nisl aliquet nunc, quis aliquam nisl nunc sit amet nisl.' 
        },
        {
            id: 2,
            recipient: 'John Doe',
            createdBy: 'Dummy',
            status: true,
            message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl eget aliquam ultricies, nunc nisl aliquet nunc, quis aliquam nisl nunc sit amet nisl.'
        },
        {
            id: 3,
            recipient: 'John Doe',
            createdBy: 'Dummy',
            status: true,
            message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl eget aliquam ultricies, nunc nisl aliquet nunc, quis aliquam nisl nunc sit amet nisl.'
        },
        {
            id: 4,
            recipient: 'John Doe',
            createdBy: 'Dummy',
            status: true,
            message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl eget aliquam ultricies, nunc nisl aliquet nunc, quis aliquam nisl nunc sit amet nisl.'
        },
        {
            id: 5,
            recipient: 'John Doe',
            createdBy: 'Dummy',
            status: true,
            message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl eget aliquam ultricies, nunc nisl aliquet nunc, quis aliquam nisl nunc sit amet nisl.'
        },
        {
            id: 6,
            recipient: 'John Doe',
            createdBy: 'Dummy',
            status: true,
            message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl eget aliquam ultricies, nunc nisl aliquet nunc, quis aliquam nisl nunc sit amet nisl.'
        },
        {
            id: 7,
            recipient: 'John Doe',
            createdBy: 'Dummy',
            status: true,
            message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl eget aliquam ultricies, nunc nisl aliquet nunc, quis aliquam nisl nunc sit amet nisl.'
        }
    ]

    const Paginate = () => <Pagination total={messages.length} limit={10} page={1} navigate={ ()=> null } />
    
    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">    
            <div className="flex justify-between items-center mt-1 mb-5">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-inv-item"
                    type="text"
                    placeholder="Search Recent Messages" />
                <span className="flex items-center">
                    <RangePicker 
                        onChange={selectRange}
                        ranges={{
                            'Today': [moment().startOf('day'), moment().endOf('day')],
                            'Yesterday': [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
                            'This Week': [moment().startOf('week'), moment().endOf('week')],
                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                        }}/>
                    <Link to="/app/marketing/messages/new">
                        <button className="btn ml-2 py-2.5 hisani-btn-green-light text-white">New Message</button>
                    </Link>
                </span>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200 px-6 py-4">
                <header className="py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">Messages</h2>
                </header>
                <Receive
                    error={invError}
                    loading={invLoading}
                    progress>
                    {   
                        messages.length > 0 ?
                            <table className="table-auto w-full">
                                {/* Table header */}
                                <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                    <tr>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">No</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Recipients</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">Sent By</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">Status</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">Message</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center"></div>
                                        </th>
                                    </tr>
                                </thead>
                                {/* Table body */}
                                <tbody className="text-sm font-medium divide-y divide-gray-100">
                                    {
                                        messages.map((message, key) =>
                                            <tr>
                                                <td className="p-2">
                                                    <div className="text-center">{((page - 1) * limit) + key + 1}.</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="">{message?.recipient}</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="text-center text-ellipsis overflow-hidden ...">{message?.createdBy}</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="text-center">{message?.status ? 'Sent' : 'Pending'}</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="text-center">{ trimText(message.message, 20) }</div>
                                                </td>
                                                <td className="p-2 text-center">
                                                    <Dropdown
                                                        overlay={
                                                            <Menu>
                                                                <Link to={`/app/marketing/messages/${message.id}`}>
                                                                    <Menu.Item>View</Menu.Item>
                                                                </Link>
                                                                {
                                                                    !message?.status &&
                                                                    <>
                                                                        {/* set up link for resending sms */}
                                                                        <Menu.Item>Resend Message</Menu.Item>
                                                                    </>
                                                                }
                                                            </Menu>
                                                        }>
                                                        <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                    </Dropdown>
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                            :
                            <div className="w-full h-16 flex items-center justify-center">
                                <p className="font-semibold text-base">Please click above to send a new message</p>
                            </div>
                    }
                </Receive>
                {Paginate}
            </div>
            <Switch>
                <Route path="/app/marketing/messages/new">
                    <NewMessage path="/app/marketing/messages" onClose={refetch} />
                </Route>
                <Route path="/app/marketing/messages/:id">
                    <Message path="/app/marketing/messages" />
                </Route>
            </Switch>
        </div>
    )
}

export default Messages 